var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneButtonCut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 37.423L17.9103 23.5127C24.479 23.1263 30.275 26.9903 34.3321 34.525",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7173 23.513C17.7173 23.3585 27.7636 10.4399 32.7867 4",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1604 23.7075C23.5931 21.3263 24.5329 20.2433 26.4108 18.6843",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9456 33.3674C38.9897 27.7376 42.541 25.5461 48.049 20.4231C43.1002 26.4131 40.2818 29.708 34.5252 34.5266",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8777 37.8094C37.7636 36.4155 38.7851 35.604 40.128 33.7522",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8777 42.8324C37.7212 42.6827 50.9391 30.1545 56.7431 23.3193",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0707 42.8316C36.4444 39.0271 36.0496 37.2431 34.332 34.7173L27.8812 40.2489L17.4812 41.0192C21.7182 46.4118 26.3404 51.4192 23.259 55.271L36.0707 42.8316Z",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.921 35.8574C23.7303 36.3204 23.0701 36.6454 22.3385 36.344C21.6069 36.0427 21.3671 35.347 21.5578 34.884C21.7485 34.421 22.4086 34.0961 23.1403 34.3974C23.8719 34.6988 24.1117 35.3944 23.921 35.8574Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.3571,
    y: 33.4392,
    width: 0.193198,
    height: 6.44727,
    transform: "rotate(-45 20.3571 33.4392)",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.193198
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8814 40.3907L16.9559 40.9072M16.9559 40.9072C14.0535 37.8086 10.2979 32.8166 4.49359 36.6037C1.07929 43.3171 16.2729 58.4654 22.5895 55.7112C27.1984 51.752 21.1483 45.3828 16.9559 40.9072Z",
    stroke: "#757575",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneButtonCut);
export default __webpack_public_path__ + "static/media/one_button_cut.fed8160e85cc0b8bb73c3ec9528268bc.svg";
export { ForwardRef as ReactComponent };